export enum Dashboard {
  AGREEMENT_REVENUE_OVERVIEW = 'agreementRevenueOverview',
  AGREEMENT_REVENUE_CHANGE = 'agreementRevenueChange',
}

export enum DashboardWhitespace {
  WHITESPACE_AGREEMENT_TYPE = 'whitespaceAgreementType',
  WHITESPACE_PRODUCT_ADDITIONS = 'whitespaceProductAdditions',
  WHITESPACE_AGREEMENT_ADDITION_MAPPING = 'whitespaceAgreementAdditionMapping',
}

export enum DashboardProfitability {
  PROFITABILITY_ACCOUNT = 'profitabilityAccount',
  PROFITABILITY_CUSTOMER = 'profitabilityCustomer',
  PROFITABILITY_COMPANY_DETAIL = 'profitabilityCompanyDetail',
}

export enum DashboardCumulativeProfitability {
  PROFITABILITY_CUMULATIVE_COMPANY_DETAIL = 'profitabilityCumulativeCompanyDetail',
}
